function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { ProjectCard } from '@edusense/features-project';
import { QuotedContentCard, AuthorContainer, AuthorAvatar, AuthorName, UsernameSeparator, DateText, QuotedContentText, MediaThumbnail } from './styles';
import { processTextWithLinks, formatDate } from './utils';
/**
 * 인용된 콘텐츠 렌더러 컴포넌트
 */ var QuotedContentRenderer = function(param) {
    var quotedContent = param.quotedContent, onQuotedContentClick = param.onQuotedContentClick;
    var _quotedContent_images, _quotedContent_videos;
    if (!quotedContent) return null;
    // 인용된 콘텐츠 클릭 핸들러
    var handleClick = function(e) {
        e.stopPropagation();
        if (quotedContent.id) {
            onQuotedContentClick(quotedContent.id, quotedContent.type || 'post');
        }
    };
    // 프로젝트 타입일 경우 ProjectCard 렌더링
    if (quotedContent.type === 'project') {
        var _quotedContent_project_author, _quotedContent_project_author1, _quotedContent_project_author2;
        // 프로젝트 정보 변환
        var projectData = _object_spread({
            id: quotedContent.id,
            title: quotedContent.content,
            description: quotedContent.content,
            thumbnail: quotedContent.thumbnail || '',
            tags: quotedContent.tags || [],
            author: {
                id: quotedContent.author.id,
                name: quotedContent.author.name,
                avatar: quotedContent.author.profileImage
            },
            createdAt: typeof quotedContent.createdAt === 'string' ? quotedContent.createdAt : quotedContent.createdAt.toISOString(),
            views: quotedContent.views || 0,
            likes: quotedContent.likes || 0,
            comments: quotedContent.comments || 0,
            starCount: quotedContent.starCount || 0
        }, quotedContent.project ? _object_spread_props(_object_spread({}, quotedContent.project), {
            // project 객체에 author가 있으면 원래 author에 덮어씌우지 않도록 제외
            author: {
                id: ((_quotedContent_project_author = quotedContent.project.author) === null || _quotedContent_project_author === void 0 ? void 0 : _quotedContent_project_author.id) || quotedContent.author.id,
                name: ((_quotedContent_project_author1 = quotedContent.project.author) === null || _quotedContent_project_author1 === void 0 ? void 0 : _quotedContent_project_author1.name) || quotedContent.author.name,
                avatar: ((_quotedContent_project_author2 = quotedContent.project.author) === null || _quotedContent_project_author2 === void 0 ? void 0 : _quotedContent_project_author2.profileImage) || quotedContent.author.profileImage
            }
        }) : {});
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                marginTop: '0.75rem'
            }
        }, /*#__PURE__*/ React.createElement(ProjectCard, {
            project: projectData,
            variant: "compact",
            onViewDetails: function() {
                return onQuotedContentClick(quotedContent.id, 'project');
            },
            className: "border border-gray-200 rounded-xl overflow-hidden"
        }));
    }
    // 미디어 수 계산
    var mediaCount = (((_quotedContent_images = quotedContent.images) === null || _quotedContent_images === void 0 ? void 0 : _quotedContent_images.length) || 0) + (((_quotedContent_videos = quotedContent.videos) === null || _quotedContent_videos === void 0 ? void 0 : _quotedContent_videos.length) || 0);
    // 기존 인용 콘텐츠 렌더링 (post, tweet 등)
    return /*#__PURE__*/ React.createElement(QuotedContentCard, {
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement(AuthorContainer, null, /*#__PURE__*/ React.createElement(AuthorAvatar, null, /*#__PURE__*/ React.createElement("img", {
        src: quotedContent.author.profileImage || '/default-profile.png',
        alt: quotedContent.author.name,
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    })), /*#__PURE__*/ React.createElement(AuthorName, null, quotedContent.author.name), quotedContent.author.verified && /*#__PURE__*/ React.createElement("svg", {
        style: {
            height: '1rem',
            width: '1rem',
            marginLeft: '0.125rem',
            color: '#3b82f6'
        },
        viewBox: "0 0 24 24",
        fill: "currentColor"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    })), /*#__PURE__*/ React.createElement(UsernameSeparator, null, "@", quotedContent.author.username), /*#__PURE__*/ React.createElement(DateText, null, "\xb7 ", formatDate(quotedContent.createdAt))), /*#__PURE__*/ React.createElement(QuotedContentText, null, processTextWithLinks(quotedContent.content)), mediaCount > 0 && /*#__PURE__*/ React.createElement(MediaThumbnail, null, quotedContent.images && quotedContent.images.length > 0 ? /*#__PURE__*/ React.createElement("img", {
        src: quotedContent.images[0],
        alt: "미디어",
        style: {
            width: '100%',
            height: '100%',
            objectFit: 'cover'
        }
    }) : quotedContent.videos && quotedContent.videos.length > 0 ? /*#__PURE__*/ React.createElement("div", {
        style: {
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#1f2937'
        }
    }, /*#__PURE__*/ React.createElement("svg", {
        style: {
            width: '2.5rem',
            height: '2.5rem',
            color: 'white',
            opacity: '0.7'
        },
        fill: "currentColor",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M8 5v14l11-7z"
    }))) : null, mediaCount > 1 && /*#__PURE__*/ React.createElement("div", {
        style: {
            position: 'absolute',
            right: '0.25rem',
            top: '0.25rem',
            backgroundColor: 'rgba(31, 41, 55, 0.7)',
            color: 'white',
            fontSize: '0.75rem',
            padding: '0 0.375rem',
            borderRadius: '0.25rem'
        }
    }, "+", mediaCount - 1)));
};
export default QuotedContentRenderer;
